module.exports = __webpack_public_path__ + "static/media/Alba soffa U-soffa FS 210_3 OEBR tyg genesis Dove 3 detalj 2024 7 fyrkant.a3a75281.jpg";